import type { DoctorShiftRule, TimeCondition, RuleType } from '../../domain/doctorShiftRule';
import { validateTimeConditions } from '../../domain/doctorShiftRule';
import type {
  DoctorShiftRuleRepository,
  CreateDoctorShiftRuleData
} from './ports/DoctorShiftRuleRepository';

export interface CreateDoctorShiftRuleInput {
  doctorIds: string[];
  ruleType: RuleType;
  timeConditions: TimeCondition[];
}

export interface CreateDoctorShiftRuleOutput {
  success: boolean;
  rules?: DoctorShiftRule[];
  errors?: string[];
}

/**
 * 医師シフトルールを作成するUseCase（複数医師対応）
 * @param repository DoctorShiftRuleRepository リポジトリインスタンス
 * @param input CreateDoctorShiftRuleInput 作成データ（医師ID配列、ルールタイプ、時間条件）
 * @returns Promise<CreateDoctorShiftRuleOutput> 作成結果（成功時: rules、失敗時: errors）
 */
export async function createDoctorShiftRule(
  repository: DoctorShiftRuleRepository,
  input: CreateDoctorShiftRuleInput
): Promise<CreateDoctorShiftRuleOutput> {
  const errors: string[] = [];

  // 医師選択バリデーション
  if (!input.doctorIds || input.doctorIds.length === 0) {
    errors.push('医師を1名以上選択してください');
  }

  // 時間条件バリデーション
  const timeValidation = validateTimeConditions(input.timeConditions);
  if (!timeValidation.isValid) {
    errors.push(...timeValidation.errors);
  }

  if (errors.length > 0) {
    return { success: false, errors };
  }

  const data: CreateDoctorShiftRuleData = {
    doctorIds: input.doctorIds,
    ruleType: input.ruleType,
    timeConditions: input.timeConditions
  };

  const rules = await repository.create(data);

  return { success: true, rules };
}
